import { render, staticRenderFns } from "./sms-wallet.vue?vue&type=template&id=1c63279f&scoped=true"
import script from "./sms-wallet.vue?vue&type=script&lang=js"
export * from "./sms-wallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63279f",
  null
  
)

export default component.exports